import { DocumentAssociation, SystemEntity } from '@wdx/clmi/clmi-swagger-gen';

export enum DocumentPreviewMode {
    AttachFiledDocuments = 'AttachFiledDocuments',
    PreviewOnly = 'PreviewOnly',
    SearchAndPreview = 'SearchAndPreview',
}

export interface DocumentPreviewParams {
    title?: string;
    entityId?: string;
    entityType?: SystemEntity;
    sourceType?: SystemEntity;
    mode?: DocumentPreviewMode;
    initialIndex?: number;
    activeDocument?: DocumentAssociation;
    documents?: DocumentAssociation[];
    linkToId?: string;
    linkedIds?: string[];
    permittedTypes?: string[];
    hideCloseModal?: boolean;
    hideFileList?: boolean;
    queryEntity?: string;
}
